Namespace 'Profiling.Models'

class Profiling.Models.SearchQuery
  constructor: ({session}) ->
    _.extend(@, Backbone.Events)
    @session = session

  createSubQuery: ({fieldName}) =>
    subQuery = new Profiling.Models.SearchQuery
      session: filter: @get(fieldName) || {}
    @listenTo subQuery, 'filterChanged', (session) =>
      @set(fieldName, session.filter)
      @triggerFilterChanged()
    subQuery

  hasEspecificTime: => @get('date_to_ISO') || @get('date_from_ISO')

  get: (attribute) =>
    return !@get('date_to_ISO') if attribute == 'date_now'
    return {} if attribute == 'tags' and _.isUndefined(@session.filter['tags'])
    @session.filter[attribute]

  set: (attribute, value) =>
    @session.filter[attribute] = value

  resetField: (attribute) =>
    delete @session.filter[attribute]

  removeAllFilters: =>
    @session.filter = {}

  addText: (text, fieldName) =>
    fieldName ||= 'text'
    @set(fieldName, _.union(@get(fieldName) || [], [text]))

  removeText: (text, fieldName) =>
    fieldName ||= 'text'
    @set(fieldName, _.difference(@get(fieldName) || [], [text]))
    @resetField(fieldName) unless @get(fieldName)?.length

  addGeneralUser: (user) =>
    user = user.substr(1) if user[0] == '@'
    return unless user.length > 0
    @addText(user, 'general_users')

  removeGeneralUser: (user) =>
    @removeText(user, 'general_users')

  addDateFrom: (value) =>
    @set('date_from_ISO', value.toISOString())
    @removeDateFromRealtime()

  addDateTo: (value) =>
    @set('date_to_ISO', value.toISOString())
    @removeDateFromRealtime()

  addDateFromRealtime: (value, name) =>
    @set('date_from_realtime', value: value, name: name)
    @removeDateFrom()
    @removeDateTo()

  removeDateFrom: => @resetField('date_from_ISO')
  removeDateTo: => @resetField('date_to_ISO')
  removeDateFromRealtime: => @resetField('date_from_realtime')

  removePrimaryKeyword: (text) =>
    @removeText(text, 'primary_keywords')

  removeSecondaryKeyword: (text) =>
    @removeText(text, 'secondary_keywords')

  removeExcludedKeyword: (text) =>
    @removeText(text, 'excluded_keywords')

  removePrimaryTag: (text) =>
    @removeText(text, 'primary_tags')

  removeSecondaryTag: (text) =>
    @removeText(text, 'secondary_tags')

  removeExcludedTag: (text) =>
    @removeText(text, 'excluded_tags')

  setNowDate: (removeDateTo) => @removeDateTo() if removeDateTo

  triggerFilterChanged: => @trigger('filterChanged', @session)
